export default {
    "시작하기": "Get Started",
    "주요 기능": "Main features",
    "앱 정보": "Information",
    "권한": "Permission",
    "제공자": "Publisher",
    "카테고리": "Category",
    "업데이트": "Updated",
    "크기": "Size",
    "자주 찾는 질문": "FaQ",
    "웹 사이트": "Website",
    "스크린샷": "Screenshots",
    "개인정보 처리방침": "Privacy Policy",
    "다운로드": "Download",
    "최신 버전": "Lastest Version",
    "제공자 정보": "Provider Information",
    "지원 언어": "Support Languages",
    "태그": "Tags",
    "릴리즈 노트": "Release Notes",
    "기능": "Functions",
    "매뉴얼": "Manual",
    "로그인": "Login",
    "로그아웃": "Logout",
    "회원가입": "Sign Up",
    "RAYTeams 다운로드": "RAYTeams Download",
    "설치파일": "Installation File",
    "버전": "Version",
    "업데이트 날짜": "Update Date",
    "RAYFace 설치파일": "RAYFace Installation File",
    "RAYFace 매뉴얼": "RAYFace Manual",
    "미디어": "Media"
}